import { render } from "./digital_form_modal.vue?vue&type=template&id=13b0d3d9&scoped=true"
import script from "./digital_form_modal.js?vue&type=script&lang=js"
export * from "./digital_form_modal.js?vue&type=script&lang=js"

import "./digital_form_modal.vue?vue&type=style&index=0&id=13b0d3d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b0d3d9"]])

export default __exports__